/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import {
  EntityId,
  SiteAgentSettings,
  SiteAgentSettingsInput,
} from "./data-contracts";

/**
 * @description Retrieves the configuration for the AI built into the GitBook editor that assists authors with drafting and refining content changes. Use this before updating agent settings to understand the current configuration.
 * @tags site-agent-settings
 * @name GetSiteAgentSettingsById
 * @summary Get the AI agent configuration for a site
 * @request GET:/orgs/{organizationId}/sites/{siteId}/agent-settings
 * @secure
 */

// @ts-ignore
export const getSiteAgentSettingsById: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: SiteAgentSettings;
  ResponseStatusCode: 200 | 400;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/agent-settings",
  method: "get",
  streaming: false,
  tags: ["site-agent-settings"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Replaces the configuration for the AI built into the GitBook editor that helps authors draft, review, and refine content changes. Use this to customize how the AI behaves when assisting authors working on content for this site. When `brokenLinks` is omitted, the current broken links settings are kept.
 * @tags site-agent-settings
 * @name UpdateSiteAgentSettingsById
 * @summary Update the AI agent configuration for a site
 * @request PUT:/orgs/{organizationId}/sites/{siteId}/agent-settings
 * @secure
 */

// @ts-ignore
export const updateSiteAgentSettingsById: {
  route: string;
  method: "put";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: SiteAgentSettingsInput;
  RequestHeaders: {};
  ResponseBody: SiteAgentSettings;
  ResponseStatusCode: 200 | 400;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/agent-settings",
  method: "put",
  streaming: false,
  tags: ["site-agent-settings"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};
